import { requestGet } from "@/utils/dva16";
import { EGet, NTopics, RSetState } from "./contants";

export default {
	namespace: NTopics,
	state: {
		topicsList: null,
		loadTopics: false,
	},
	reducers: {
		[RSetState](state, { payload }) {
			return {
				...state,
				...payload,
			};
		},
	},
	effects: {
		async [EGet]({ payload, callback }, { call, reducer, select, effect }) {
			reducer(RSetState, { loadTopics: true });
			let res = await requestGet("topic", payload);
			reducer(RSetState, { topicsList: res, loadTopics: false });
		},
	},
};
